import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  snackbar: {
    top: 60,
    whiteSpace: 'pre',
  },
});
